interface IAuthorization {
  Authorization: string;
}

export default (accessToken: string): IAuthorization => ({
  Authorization: `Bearer ${accessToken}`,
});
